import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export default function AdminMessages() {
  const { data: items = [], isLoading } = useQuery({ queryKey: ['admin-messages'], queryFn: async () => (await api.get('/admin/messages')).data });

  return (
    <div data-testid="admin-messages-page">
      <h1 className="font-serif text-3xl text-ukgm-blue font-semibold">Contact Messages</h1>

      {isLoading ? (
        <div className="mt-8 text-ukgm-slate">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-8 text-ukgm-slate">No messages yet.</div>
      ) : (
        <div className="mt-8 space-y-3">
          {items.map(m => (
            <div key={m.id} className="bg-white rounded-2xl border border-ukgm-gold/25 p-5" data-testid={`message-${m.id}`}>
              <div className="flex items-center justify-between text-sm">
                <div className="font-serif text-ukgm-blue font-semibold">{m.name}</div>
                <div className="text-xs text-ukgm-slate">{new Date(m.created_at).toLocaleString()}</div>
              </div>
              <div className="mt-1 text-xs text-ukgm-slate">{m.email}{m.phone ? ` · ${m.phone}` : ''}</div>
              <div className="mt-2 text-sm font-semibold text-ukgm-charcoal">{m.subject}</div>
              <p className="mt-2 text-sm text-ukgm-slate whitespace-pre-line">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
